import React, { memo } from 'react';
import HBAddressCountryField from './HBAddressCountryField';
import type { CountryOption } from './HBAddressCountryField';
import useFormFieldProps, {
    FormFieldProps,
    useFormInputValidationProps
} from '../HBFormFields/useFormFieldProps';
import type { HBDropdownFieldProps } from '../HBDropdownField/HBDropdownField';

export type { CountryOption };

export type HBFormAddressCountryFieldProps = Omit<
    FormFieldProps<HBDropdownFieldProps<string>>,
    'options' | 'label'
> & {
    /** Field label. Defaults to "Country". */
    label?: string;
    /**
     * Override the auto-generated country list.
     * Defaults to all ISO 3166-1 countries from @honeybook/i18n getCountries(),
     * localized to the current locale.
     */
    countryOptions?: CountryOption[];
};

const HBFormAddressCountryField = ({
    label,
    countryOptions,
    ...props
}: HBFormAddressCountryFieldProps) => {
    const fieldProps = useFormFieldProps(props);
    const validationProps = useFormInputValidationProps(props.id);

    return (
        <HBAddressCountryField
            {...fieldProps}
            {...validationProps}
            label={label}
            countryOptions={countryOptions}
        />
    );
};

export default memo(HBFormAddressCountryField);
